import { render, staticRenderFns } from "./FiltersRenderer.vue?vue&type=template&id=2d4a981c&lang=pug&"
import script from "./FiltersRenderer.vue?vue&type=script&lang=js&"
export * from "./FiltersRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports